import {useEffect, useState} from "react";


export * as libexports from "./Libraries";
export * as examples from "./Examples";
export {default as langdata} from "./Language.json";

export const useRouteHash=()=>{
    const [hash,setHash]=useState(location.hash.split("#")[1]);
    useEffect(()=>{
        function onHashChange(){
            setHash(location.hash.split("#")[1]);
        }
        window.addEventListener("hashchange",onHashChange);
        return ()=>{
            window.removeEventListener("hashchange",onHashChange);
        }
    },[]);
    return hash;
};
